import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import gql from "graphql-tag";

import {
  ProductCategoriesBiDownload,
  ProductCategoriesBiDownloadVariables
} from "./types/ProductCategoriesBiDownload";
import {
  ProductCategoriesBiList,
  ProductCategoriesBiListVariables
} from "./types/ProductCategoriesBiList";

export const productCategoriesBiList = gql`
  ${pageInfoFragment}
  query ProductCategoriesBiList(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: ProductCategoriesFilterInput!
  ) {
    productCategories(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          category_code
          category_name
          level
        }
      }
    }
  }
`;

export const useProductCategoriesBiListQuery = makeBossQuery<
  ProductCategoriesBiList,
  ProductCategoriesBiListVariables
>(productCategoriesBiList);

export const productCategoriesBiDownload = gql`
  ${pageInfoFragment}
  query ProductCategoriesBiDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: ProductCategoriesFilterInput!
  ) {
    productCategories(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          category_code
          category_name
          level
          parent_category
        }
      }
    }
  }
`;

export const useProductCategoriesBiDownloadQuery = makeBossQuery<
  ProductCategoriesBiDownload,
  ProductCategoriesBiDownloadVariables
>(productCategoriesBiDownload);
